/* DISTRIBUSI HP — entry point: the release switch (owner only, enforced on the server) and the exports
   the shell uses. The release button stays locked until every HP screen group (A–E) is built. */
const DHP_READY = true;

// "Tampilan HP Distribusi" on the Aturan lapangan screen (owner): release / un-release `hpUiDefault`.
function DhpReleaseBlock({ onSaved }) {
  const [v, setV] = uSdh(null);
  const [busy, setBusy] = uSdh(false);
  const [ask, setAsk] = uSdh(null);
  const [err, setErr] = uSdh('');
  uEdh(() => {
    let live = true;
    window.API.distribusi.fieldRules.get().then((r) => { if (live) setV((r.data && r.data.hpUiDefault) || 'old'); }).catch((e) => { if (live) setErr(fldErrMsg(e)); });
    return () => { live = false; };
  }, []);
  const save = (val) => {
    setBusy(true); setErr('');
    window.API.distribusi.fieldRules.set({ hpUiDefault: val })
      .then((r) => { setV(r.data.hpUiDefault); if (onSaved) onSaved(r.data); })
      .catch((e) => setErr(fldErrMsg(e)))
      .finally(() => setBusy(false));
  };
  if (v == null && !err) return null;
  return (
    <div className="mlap-card mlap-release">
      <b>{trDh('dhp.releaseTitle')}</b>
      <small>{v === 'new' ? trDh('dhp.released') : trDh('dhp.releaseSub')}</small>
      {v === 'new'
        ? <button type="button" className="mlap-btn" disabled={busy} onClick={() => setAsk('old')}>{trDh('dhp.unreleaseBtn')}</button>
        : <button type="button" className="mlap-btn danger" disabled={busy || !DHP_READY} onClick={() => setAsk('new')}>{trDh('dhp.releaseBtn')}</button>}
      {v !== 'new' && !DHP_READY ? <small>{trDh('dhp.releaseLater')}</small> : null}
      {err ? <div className="mlap-err" role="alert">{err}</div> : null}
      {ask ? <FldSheet title={trDh(ask === 'new' ? 'dhp.releaseAskT' : 'dhp.unreleaseAskT')} body={trDh(ask === 'new' ? 'dhp.releaseAskB' : 'dhp.unreleaseAskB')}
        confirmLabel={trDh(ask === 'new' ? 'dhp.releaseBtn' : 'dhp.unreleaseBtn')} danger={ask === 'new'} onClose={() => setAsk(null)} onConfirm={() => { const a = ask; setAsk(null); save(a); }} /> : null}
    </div>
  );
}

window.DHP = { READY: DHP_READY, ReleaseBlock: DhpReleaseBlock, Dock: DhpDock, Entry: DhpEntry, screens: { 'dist-customers': DhpCustomers, 'dist-transactions': DhpTransactions, 'dist-deliveries': DhpDeliveries } };
